"use strict";

require("core-js/modules/es.array.iterator");

var takeAll = require("./takeAll.js");

var rangeL = require("../Lazy/rangeL.js");

module.exports = range;

function range(..._) {
  return takeAll(rangeL(..._));
}